/** @file Which commits are undone: a revert of them that is itself not undone (a reverted revert is a redo). */

/** A commit as the undo rule sees it: its rev and the rev it reverts (null for an ordinary commit). */
export type RevertLink = { rev: number; revertOf: number | null };

/**
 * The revs of `commits` that are undone, judged by the reverts among `commits` only: a commit is undone when some
 * revert of it is not undone itself (spec §8.2 undo rule). A revert always follows its target, so one pass from the
 * newest commit settles every rev after all of its reverts: O(n log n), no recursion however long the undo/redo chain.
 */
export function undoneRevs(commits: readonly RevertLink[]): Set<number> {
  const undone = new Set<number>();
  const liveRevertTargets = new Set<number>();
  for (const { rev, revertOf } of [...commits].sort((a, b) => b.rev - a.rev)) {
    if (liveRevertTargets.has(rev)) undone.add(rev);
    if (revertOf !== null && !undone.has(rev)) liveRevertTargets.add(revertOf);
  }
  return undone;
}
